import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

const FeaturedButton = ({ id }) => {
  return (
    <Link
      className="button is-link is-rounded is-medium"
      to={`/app/opportunities/${id}`}
    >
      Learn More
    </Link>
  )
}

FeaturedButton.propTypes = {
  id: PropTypes.string.isRequired,
}

export default FeaturedButton
